<script setup>
import { Link, usePage } from '@inertiajs/vue3';
import { helperStore } from "@/store/helper"
const helper = helperStore()
const page = usePage()
const company = page.props.shared_data.company
const primaryPhone = company['phone'].split(",")
import ContactFormComponent from '@/Components/Frontend/Contact/ContactFormComponent.vue';
</script>

<template>
    <section class="text-gray-600 body-font">
        <div class="container pt-20 pb-4 mx-auto">
            <div class="flex flex-wrap lg:pt-12 pt-4">

                <div class="lg:w-1/2 w-full 2xl:pr-40 xl:pr-20 lg:pr-12 pr-0 wow animate__animated animate__fadeInLeft">
                    <div class="bg-primary xl:py-16 xl:px-14 lg:py-12 lg:px-12 py-5 px-5">
                        <h1 class="title-font font-medium xl:text-3xl lg:text-2xl text-xl text-white">{{$t("contact.get_in_touch")}}</h1>
                        <p class="leading-relaxed mt-2 xl:text-xl lg:text-lg text-base text-gray-200">{{ $t("contact.get_in_touch_details") }}</p>
                        <div class="lg:mb-8 mb-4">
                            <h3 class="flex mb-3 lg:mt-6 mt-4 text-white xl:text-2xl lg:text-xl text-lg">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                                    class="text-white lg:w-6 w-5 lg:h-6 h-5 lg:mr-4 mr-2 mt-1 inline-block">
                                    <path
                                        d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 9h12v2H6V9zm8 5H6v-2h8v2zm4-6H6V6h12v2z">
                                    </path>
                                </svg>
                               {{$t("contact.email_to_us")}}
                            </h3>
                            <nav class="list-none mx-auto lg:px-10 md:px-4 px-8">
                                <li class="title-font font-light xl:text-lg text-base text-gray-200 mb-2">{{ $t("contact.email_to_us_tag") }}</li>
                                <li class="title-font font-light xl:text-lg text-base text-white">helpcenter@nochinta.xyz</li>
                            </nav>
                        </div>
                        <div class="lg:mb-8 mb-4">
                            <h3 class="flex mb-3 lg:mt-6 mt-4 text-white xl:text-2xl lg:text-xl text-lg">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                                    class="text-white lg:w-6 w-5 lg:h-6 h-5 lg:mr-4 mr-2 mt-1 inline-block">
                                    <path
                                        d="M20 6h-4V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-6 0h-4V4h4v2z">
                                    </path>
                                </svg>
                                {{$t("contact.office")}}
                            </h3>
                            <nav class="list-none mx-auto lg:px-10 md:px-4 px-8">
                                <li class="title-font font-light xl:text-lg text-base text-white">{{ $t("contact.office_address") }}</li>
                            </nav>
                        </div>
                        <div class="lg:mb-6 mb-4">
                            <h3 class="flex mb-3 lg:mt-6 mt-4 text-white xl:text-2xl lg:text-xl text-lg">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                                    class="text-white lg:w-6 w-5 lg:h-6 h-5 lg:mr-4 mr-2 mt-1 inline-block">
                                    <path
                                        d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z">
                                    </path>
                                </svg>
                                {{$t("contact.phone")}}
                            </h3>
                            <nav class="list-none mx-auto lg:px-10 md:px-4 px-8">
                                <li class="title-font font-light  xl:text-lg text-base text-gray-200 mb-2">{{ $t("contact.working_day") }}</li>
                                <li class="title-font font-light  xl:text-lg lg:text-base text-sm text-white">+880 9646 750 750</li>
                            </nav>
                        </div>
                        <div class="xl:mt-20 lg:mt-12 mt-4">
                            <div class="flex flex-wrap items-center justify-center pt-2 space-x-3">

                                <a v-if="company?.fb" :href="company?.fb" target="_blank"
                                    class="text-gray-50 hover:text-[#d3d3d3] border border-gray-300 hover:border-[#d3d3d3] rounded-full xl:h-12 xl:w-12 lg:h-9 lg:w-9 h-8 w-8 transition duration-300 flex items-center justify-center">
                                    <i class="fa-brands fa-facebook xl:text-2xl lg:text-lg text-base"></i>
                                </a>
                                <a v-if="company?.in" :href="company?.in" target="_blank"
                                    class=" text-gray-50 hover:text-[#d3d3d3] border border-gray-300 hover:border-[#d3d3d3] rounded-full xl:h-12 xl:w-12 lg:h-9 lg:w-9 h-8 w-8 transition duration-300 flex items-center justify-center">
                                    <i class="fa-brands fa-instagram xl:text-2xl lg:text-lg text-base"></i>
                                </a>
                                <a v-if="company?.yt" :href="company?.yt" target="_blank"
                                    class=" text-gray-50 hover:text-[#d3d3d3] border border-gray-300 hover:border-[#d3d3d3] rounded-full xl:h-12 xl:w-12 lg:h-9 lg:w-9 h-8 w-8 transition duration-300 flex items-center justify-center">
                                    <i class="fa-brands fa-youtube xl:text-2xl lg:text-lg text-base"></i>
                                </a>
                                <a v-if="company?.tw" :href="company?.tw" target="_blank"
                                    class=" text-gray-50 hover:text-[#d3d3d3] border border-gray-300 hover:border-[#d3d3d3] rounded-full xl:h-12 xl:w-12 lg:h-9 lg:w-9 h-8 w-8 transition duration-300 flex items-center justify-center">
                                    <i class="fa-brands fa-twitter xl:text-2xl lg:text-lg text-base"></i>
                                </a>
                                <a v-if="company?.li" :href="company?.li" target="_blank"
                                    class=" text-gray-50 hover:text-[#d3d3d3] border border-gray-300 hover:border-[#d3d3d3] rounded-full xl:h-12 xl:w-12 lg:h-9 lg:w-9 h-8 w-8 transition duration-300 flex items-center justify-center">
                                    <i class="fa-brands fa-linkedin xl:text-2xl lg:text-lg text-base"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <ContactFormComponent/>
            </div>
        </div>
    </section>
</template>

<style scoped></style>
